import { Box, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import { surface } from "@utils/designSystem";
import { fontSize } from "@utils/tokens";

export type PageHeaderProps = {
  eyebrow?: string;
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
};

export default function PageHeader({ eyebrow, title, subtitle, actions }: PageHeaderProps) {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "stretch", sm: "center" }}
      spacing={1.5}
      sx={{ width: "100%" }}
    >
      <Box sx={{ minWidth: 0 }}>
        {eyebrow && (
          <Typography sx={{ fontSize: fontSize.xs, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", color: surface.primary, mb: 0.5 }}>
            {eyebrow}
          </Typography>
        )}
        <Typography variant="h1" sx={{ fontSize: fontSize["4xl"], fontWeight: 700, color: "text.primary", lineHeight: 1.2 }}>
          {title}
        </Typography>
        {subtitle && <Box sx={{ mt: 0.5 }}>{subtitle}</Box>}
      </Box>
      {actions && <Box sx={{ flexShrink: 0 }}>{actions}</Box>}
    </Stack>
  );
}
